import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./faq.css";
import { FaChevronUp } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
import { FcShipped } from "react-icons/fc";
import { useEffect } from "react";
const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const fben ={
    "1": "Frequently Asked Questions (FAQs)",
    "2": "Home"
  }
  const fbhi ={
    "1": "अक्सर पूछे जाने वाले प्रश्न (FAQs)",
    "2": "होम"
};
  const fbka ={
    "1": "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು (FAQs)",
    "2": "ಮರಳಿ ಪ್ರಥಮ ಪುಟಕ್ಕೆ"
  }
  
  const fbte ={
    "1": "తరచుగా అడిగే ప్రశ్నలు (FAQs)",
    "2": "హోం"
  }
  const fbta ={
    "1": "அடிக்கடி கேட்கப்படும் கேள்விகள் (FAQ)",
    "2": "வீடு"
  }
  const faqDatahi =[
    {
    question: "मैं ऑर्डर कैसे करूं?",
    answer: (
      <>
        <p>ऑर्डर करने के लिए:</p>
        <ol>
          <li>हमारे उत्पादों को ब्राउज़ करें और अपनी पसंदीदा वस्तुओं को कार्ट में जोड़ें।</li>
          <li>जब आप तैयार हों, तो कार्ट आइकन पर क्लिक करें और चेकआउट पर जाएं।</li>
          <li>अपनी डिलीवरी विवरण भरें और अपनी पसंदीदा भुगतान विधि चुनें।</li>
          <li>अपने ऑर्डर की समीक्षा करें और अपनी खरीद की पुष्टि करें।</li>
          <li>जब आपका ऑर्डर सफलतापूर्वक रखा जाएगा, तो आपको एक ऑर्डर पुष्टि ईमेल प्राप्त होगा।</li>
        </ol>
      </>
    ),
  },
  {
    question: "आप कौन-कौन से भुगतान विकल्प स्वीकार करते हैं?",
    answer: (
      <>
        <p>हम निम्नलिखित भुगतान विधियां स्वीकार करते हैं:</p>
        <ul>
          <li>क्रेडिट/डेबिट कार्ड (वीज़ा, मास्टरकार्ड आदि)</li>
          <li>नेट बैंकिंग</li>
          <li>यूपीआई (यूनिफाइड पेमेंट्स इंटरफेस)</li>
          <li>कैश ऑन डिलीवरी (COD) (यदि लागू हो)</li>
        </ul>
      </>
    ),
  },
  {
    question: "मैं अपने ऑर्डर को कैसे ट्रैक कर सकता/सकती हूं?",
    answer: (
      <p>
        एक बार जब आपका ऑर्डर भेज दिया जाता है, तो आपको एक ट्रैकिंग नंबर और कूरियर सेवा विवरण प्राप्त होगा। 
        आप इस ट्रैकिंग नंबर का उपयोग कूरियर की वेबसाइट पर अपने ऑर्डर की स्थिति ट्रैक करने के लिए कर सकते हैं 
        या प्रदान किए गए ट्रैकिंग लिंक का उपयोग कर सकते हैं।
      </p>
    ),
  },
  {
    question: "क्या मैं ऑर्डर देने के बाद उसे संशोधित या रद्द कर सकता/सकती हूं?",
    answer: (
      <>
        <p>आप केवल तभी अपने ऑर्डर को संशोधित या रद्द कर सकते हैं जब इसे शिप नहीं किया गया हो।</p>
        <p>यदि आपका ऑर्डर अभी भी प्रोसेसिंग चरण में है, तो तुरंत हमारे ग्राहक सहायता से संपर्क करें:</p>
        <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>
        <p>संशोधन या रद्दीकरण का अनुरोध करने के लिए।</p>
      </>
    ),
  },
  {
    question: "मैं किसी उत्पाद को कैसे वापस करूं या बदलूं?",
    answer: (
      <>
        <p>आप डिलीवरी की तारीख से 7-10 दिनों के भीतर किसी उत्पाद को वापस या एक्सचेंज कर सकते हैं, बशर्ते कि वह अपनी मूल, बिना उपयोग की गई स्थिति में हो और पैकेजिंग सुरक्षित हो। अधिक जानकारी के लिए कृपया हमारी वापसी और विनिमय नीति देखें।</p>
        <p>वापसी या एक्सचेंज शुरू करने के लिए:</p>
        <ol>
          <li>हमारी ग्राहक सहायता टीम से संपर्क करें: <a href="mailto:support@terrainternational.in">support@terrainternational.in</a></li>
          <li>अपना ऑर्डर नंबर और वापसी या एक्सचेंज का कारण बताएं।</li>
          <li>हमारी टीम द्वारा प्रदान किए गए वापसी निर्देशों का पालन करें।</li>
        </ol>
      </>
    ),
  },
  {
    question: "मुझे मेरी धनवापसी कब मिलेगी?",
    answer: (
      <p>
        एक बार जब हमें आपका लौटाया हुआ उत्पाद प्राप्त हो जाएगा, तो हम 7-10 कार्यदिवसों के भीतर आपकी धनवापसी को संसाधित कर देंगे। 
        धनवापसी उसी भुगतान विधि में की जाएगी जिसका उपयोग आपने खरीदारी के समय किया था। 
        आपके भुगतान प्रदाता के आधार पर, धनवापसी आपके खाते में दिखाई देने में कुछ अतिरिक्त दिन लग सकते हैं।
      </p>
    ),
  },
  {
    question: "यह कैसे काम करता है?",
    answer: (
      <section class="contact-us-wrap">
        <div>
          <div class="row justify-content-center">
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src="assets/img/cart.png" alt="" style={{ height: "50px" }} />
                <h6>ऑर्डर</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <div>
                <h6>ऑर्डर प्रक्रिया तब शुरू होती है जब ग्राहक उत्पादों का चयन करते हैं और भुगतान करके अपनी खरीद की पुष्टि करते हैं।</h6>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <FcShipped style={{ fontSize: "50px" }} />
                <h6>शिपिंग</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <h6>एक बार ऑर्डर प्राप्त हो जाने पर, इसे संसाधित, पैक और विश्वसनीय कूरियर सेवाओं के माध्यम से भेज दिया जाता है।</h6>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src="assets/img/door.png" alt="" style={{ height: "50px" }} />
                <h6>डोर डिलीवरी</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <h6>अंतिम चरण डोर डिलीवरी है, जहां उत्पाद को सीधे ग्राहक के पते पर वितरित किया जाता है।</h6>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    question: "अगर मुझे कोई टूटा हुआ या दोषपूर्ण उत्पाद मिले तो मैं क्या करूं?",
    answer: (
      <>
        <p>यदि आपको कोई टूटा हुआ या दोषपूर्ण उत्पाद प्राप्त होता है, तो कृपया तुरंत हमसे संपर्क करें:</p>
        <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>
        <p>नीचे दी गई जानकारी के साथ:</p>
        <ul>
          <li>आपका ऑर्डर नंबर।</li>
          <li>दोषपूर्ण या क्षतिग्रस्त उत्पाद की एक फोटो।</li>
          <li>पैकेजिंग की एक फोटो।</li>
        </ul>
        <p>हम आपको बिना किसी अतिरिक्त शुल्क के उत्पाद लौटाने या बदलने में सहायता करेंगे।</p>
      </>
    ),
  },
  {
    question: "शिपिंग शुल्क कैसे निर्धारित किए जाते हैं?",
    answer: (
      <p>
        शिपिंग शुल्क आपके डिलीवरी पते, उत्पाद(ओं) के वजन और आपके द्वारा चुनी गई शिपिंग विधि के आधार पर निर्धारित किए जाते हैं। 
        आप चेकआउट प्रक्रिया के दौरान शिपिंग लागत देख सकते हैं, इससे पहले कि आप अपना ऑर्डर अंतिम रूप दें।
      </p>
    ),
  },
  {
    question: "क्या आप अंतरराष्ट्रीय स्तर पर शिपिंग करते हैं?",
    answer: (
      <p>
        हां, हम चुनिंदा देशों में अंतरराष्ट्रीय शिपिंग प्रदान करते हैं। 
        आप चेकआउट के दौरान अपना पता दर्ज करके जांच सकते हैं कि क्या हम आपके स्थान पर डिलीवरी करते हैं। 
        अंतरराष्ट्रीय शिपिंग शुल्क लागू होंगे।
      </p>
    ),
  },
  {
    question: "क्या आपके उत्पाद प्रामाणिक और असली हैं?",
    answer: (
      <p>
        हां, हमारी वेबसाइट पर बेचे जाने वाले सभी उत्पाद 100% प्रामाणिक हैं और सीधे निर्माताओं से आते हैं। 
        हम अपने बेचे जाने वाले उत्पादों की गुणवत्ता और प्रामाणिकता की गारंटी देते हैं।
      </p>
    ),
  },
  {
    question: "मैं ग्राहक सहायता से कैसे संपर्क करूं?",
    answer: (
      <>
        <p>किसी भी प्रश्न या चिंता के लिए, आप हमारी ग्राहक सहायता टीम से निम्नलिखित माध्यमों से संपर्क कर सकते हैं:</p>
        <ul>
          <li>ईमेल: <a href="mailto:support@terrainternational.in">support@terrainternational.in</a></li>
          <li>फोन: 7022519222</li>
        </ul>
        <p>हम 24/7 उपलब्ध हैं और सभी प्रश्नों का उत्तर 48 घंटों के भीतर देने का प्रयास करते हैं।</p>
      </>
    ),
  },
  {
    question: "क्या आप छूट या प्रमोशन प्रदान करते हैं?",
    answer: (
      <p>
        हां, हम समय-समय पर छूट, प्रमोशन और विशेष ऑफ़र प्रदान करते हैं। 
        नवीनतम ऑफ़र के बारे में अपडेट रहने के लिए हमारे न्यूज़लेटर की सदस्यता लें या हमें सोशल मीडिया पर फॉलो करें।
      </p>
    ),
  },
  {
    question: "अगर मैं अपना पासवर्ड भूल जाऊं तो क्या करूं?",
    answer: (
      <p>
        यदि आप अपना पासवर्ड भूल गए हैं, तो लॉगिन पेज पर "Forgot Password" लिंक पर क्लिक करें। 
        अपना पंजीकृत ईमेल पता दर्ज करें, और हम आपको पासवर्ड रीसेट करने के निर्देश भेजेंगे।
      </p>
    ),
  },
];  
  const faqDatate = [
    {
      "question": "నేను ఆర్డర్‌ను ఎలా ఇవ్వగలను?",
      "answer": <><p>ఆర్డర్‌ను ఇవ్వడానికి:</p><ol><li>మా ఉత్పత్తులను బ్రౌజ్ చేసి, మీకు కావాల్సిన వాటిని కార్ట్‌లో జోడించండి.</li><li>తయారైన తర్వాత, కార్ట్ ఐకాన్‌పై క్లిక్ చేసి, చెకౌట్‌కు వెళ్లండి.</li><li>మీ డెలివరీ వివరాలను నమోదు చేసి, మీకు ఇష్టమైన చెల్లింపు పద్ధతిని ఎంచుకోండి.</li><li>మీ ఆర్డర్‌ను సమీక్షించి, కొనుగోలును ధృవీకరించండి.</li><li>మీ ఆర్డర్ విజయవంతంగా ఇవ్వబడిన తర్వాత మీకు ఆర్డర్ ధృవీకరణ ఇమెయిల్ వస్తుంది.</li></ol></>
    },
    {
      "question": "మీరు ఏ చెల్లింపు పద్ధతులను అంగీకరిస్తారు?",
      "answer": <><p>మేము కింది చెల్లింపు విధానాలను అంగీకరిస్తాము:</p><ul><li>క్రెడిట్/డెబిట్ కార్డులు (వీసా, మాస్టర్‌కార్డ్ మొదలైనవి)</li><li>నెట్ బ్యాంకింగ్</li><li>UPI (యూనిఫైడ్ పేమెంట్స్ ఇంటర్‌ఫేస్)</li><li>క్యాష్ ఆన్ డెలివరీ (COD) (అమలులో ఉంటే)</li></ul></>
    },
    {
      "question": "నా ఆర్డర్‌ను నేను ఎలా ట్రాక్ చేయగలను?",
      "answer": <p>మీ ఆర్డర్ రవాణా చేసిన తర్వాత, మీకు ట్రాకింగ్ నంబర్ మరియు క్యారియర్ వివరాలు అందించబడతాయి. మీరు ఈ ట్రాకింగ్ నంబర్‌ను క్యారియర్ వెబ్‌సైట్‌లో లేదా అందించిన లింక్ ద్వారా మీ ఆర్డర్ స్థితిని ట్రాక్ చేయడానికి ఉపయోగించవచ్చు.</p>
    },
    {
      "question": "ఆర్డర్ ఇచ్చిన తర్వాత నేను దాన్ని మార్చగలనా లేదా రద్దు చేయగలనా?",
      "answer": <><p>మీ ఆర్డర్ ఇంకా పంపిణీ కాకపోతే దానిని మార్చవచ్చు లేదా రద్దు చేయవచ్చు. మీ ఆర్డర్ ప్రాసెసింగ్ దశలో ఉంటే, వెంటనే మా కస్టమర్ సపోర్ట్‌ను సంప్రదించండి:<a href='mailto:support@terrainternational.in'>support@terrainternational.in</a> మార్పులు లేదా రద్దు చేయడానికి అభ్యర్థించండి.</p></>
    },
    {
      "question": "నేను ఉత్పత్తిని ఎలా మార్చవచ్చు లేదా తిరిగి పంపించవచ్చు?",
      "answer": <><p>మీరు ఉత్పత్తిని డెలివరీ చేసిన 7-10 రోజులలోపుగా, అది అసలు ప్యాకేజింగ్‌తో, వాడని పరిస్థితిలో ఉంటే తిరిగి పంపించవచ్చు లేదా మార్చవచ్చు. మరింత సమాచారం కోసం మా రిటర్న్ & ఎక్స్ఛేంజ్ పాలసీని చూడండి.</p><p>తిరిగి పంపించడానికి లేదా మార్పు కోరేందుకు:</p><ol><li>మా కస్టమర్ సపోర్ట్‌ను సంప్రదించండి: <a href='mailto:support@terrainternational.in'>support@terrainternational.in</a>.</li><li>మీ ఆర్డర్ నంబర్ మరియు మార్పు/తిరిగి పంపడానికి కారణాన్ని తెలియజేయండి.</li><li>మా టీమ్ అందించిన మార్గదర్శకాలను అనుసరించండి.</li></ol></>
    },
    {
      "question": "నా రిఫండ్ ఎప్పుడు వస్తుంది?",
      "answer": <p>మీ తిరిగి పంపిన ఉత్పత్తిని స్వీకరించిన తర్వాత, మేము 7-10 పని రోజులలోపు మీ రిఫండ్ ప్రాసెస్ చేస్తాము. ఇది మీ అసలు చెల్లింపు పద్ధతికి తిరిగి జమ చేయబడుతుంది.</p>
    },
    {
      "question": "మీ ఉత్పత్తులు నిజమైనవా?",
      "answer": <p>అవును, మా వెబ్‌సైట్‌లో అమ్మే అన్ని ఉత్పత్తులు 100% నిజమైనవే. అవి నేరుగా తయారీదారుల నుండి పొందబడతాయి.</p>
    },
    {
      "question": "మీరు అంతర్జాతీయంగా షిప్పింగ్ చేస్తారా?",
      "answer": <p>అవును, మేము కొన్ని ఎంపిక చేసిన దేశాలకు అంతర్జాతీయ షిప్పింగ్ అందిస్తాము. మీ చిరునామా చెకౌట్ సమయంలో నమోదు చేసి షిప్పింగ్ ఎంపికలు చూడవచ్చు.</p>
    },
    {
      "question": "ఇది ఎలా పనిచేస్తుంది?",
      "answer": <section class='contact-us-wrap'><div><div class='row justify-content-center'><div class='col-xl-3 col-lg-6 col-md-6'><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}><img src='assets/img/cart.png' alt='' style={{ height: '50px' }} /><h6>ఆర్డర్</h6><div style={{ height: '5px', width: '50px', backgroundColor: 'green', borderRadius: '50px', marginBottom: '2vh' }}></div></div><div><h6>వినియోగదారులు ఉత్పత్తులను ఎంచుకొని, చెల్లింపు ద్వారా కొనుగోలు ధృవీకరిస్తారు.</h6></div></div><div class='col-xl-3 col-lg-6 col-md-6'><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}><FcShipped style={{ fontSize: '50px' }} /><h6>షిప్పింగ్</h6><div style={{ height: '5px', width: '50px', backgroundColor: 'green', borderRadius: '50px', marginBottom: '2vh' }}></div></div><h6>ఆర్డర్ అందుకున్న తర్వాత, ప్రాసెస్ చేసి, ప్యాక్ చేసి, నమ్మకమైన కొరియర్ సేవల ద్వారా రవాణా చేయబడుతుంది.</h6></div><div class='col-xl-3 col-lg-6 col-md-6'><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}><img src='assets/img/door.png' alt='' style={{ height: '50px' }} /><h6>డోర్ డెలివరీ</h6><div style={{ height: '5px', width: '50px', backgroundColor: 'green', borderRadius: '50px', marginBottom: '2vh' }}></div></div><h6>చివరి దశ వినియోగదారుని చిరునామాకు ఉత్పత్తిని నేరుగా అందించడం.</h6></div></div></div></section>
    },
    {
      "question": "షిప్పింగ్ రుసుములు ఎలా లెక్కించబడతాయి?",
      "answer": <p>షిప్పింగ్ రుసుములు మీ చిరునామా, ఉత్పత్తి బరువు మరియు షిప్పింగ్ విధానంపై ఆధారపడి ఉంటాయి. చెకౌట్ సమయంలో ఖర్చును చూడవచ్చు.</p>
    },
    {
      "question": "మీరు డిస్కౌంట్లు లేదా ప్రోమోషన్లు అందిస్తారా?",
      "answer": <p>అవును, మేము అప్పుడప్పుడూ డిస్కౌంట్లు మరియు ప్రత్యేక ఆఫర్లు అందిస్తాము. తాజా డీల్స్ కోసం మా న్యూస్లెట్టర్‌కు సభ్యత్వాన్ని పొందండి లేదా మా సోషల్ మీడియాలో మమ్మల్ని అనుసరించండి.</p>
    },
    {
      "question": "నేను నా పాస్‌వర్డ్ మర్చిపోయాను, ఏమి చేయాలి?",
      "answer": <p>మీ పాస్‌వర్డ్‌ను మర్చిపోయినట్లయితే, లాగిన్ పేజీలో 'Forgot Password' లింక్‌పై క్లిక్ చేయండి. మీ రిజిస్టర్డ్ ఇమెయిల్‌ను నమోదు చేయండి, మేము మీకు పాస్‌వర్డ్ రీసెట్ చేయడానికి సూచనలు పంపుతాము.</p>
    },
    {
      "question": "మీ కస్టమర్ సపోర్ట్‌ను ఎలా సంప్రదించాలి?",
      "answer": <><p>మీరు మమ్మల్ని సంప్రదించడానికి కింది మార్గాలను ఉపయోగించవచ్చు:</p><ul><li>ఇమెయిల్: <a href='mailto:support@terrainternational.in'>support@terrainternational.in</a></li><li>ఫోన్: 7022519222</li></ul><p>మేము 24/7 అందుబాటులో ఉంటాము మరియు 48 గంటల్లోపుగా ప్రతిస్పందిస్తాము.</p></>
    }
  ];
  const faqDatae = [
    {
      question: "How do I place an order?",
      answer: (
        <>
          <p>To place an order:</p>
          <ol>
            <li>Browse through our products and add your desired items to the cart.</li>
            <li>Once you're ready, click on the cart icon and proceed to checkout.</li>
            <li>Fill in your delivery details and choose your preferred payment method.</li>
            <li>Review your order and confirm your purchase.</li>
            <li>You will receive an order confirmation email once your order is placed successfully.</li>
          </ol>
        </>
      ),
    },
    {
      question: "What payment methods do you accept?",
      answer: (
        <>
          <p>We accept the following payment methods:</p>
          <ul>
            <li>Credit/Debit cards (Visa, MasterCard, etc.)</li>
            <li>Net Banking</li>
            <li>UPI (Unified Payments Interface)</li>
            <li>Cash on Delivery (COD) (if applicable)</li>
          </ul>
        </>
      ),
    },
    {
      question: "How can I track my order?",
      answer: <p>Once your order is dispatched, you will receive a tracking number along with the carrier details. You can use this tracking number to track the status of your order on the carrier’s website or through the tracking link provided.</p>,
    },
    {
      question: "Can I modify or cancel my order after placing it?",
      answer: (
        <>
          <p>You can modify or cancel your order only if it has not been shipped. If your order is still in the processing stage, contact our customer support immediately at</p>
          <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>
          <p>to request modifications or cancellations.</p>
        </>
      ),
    },
    {
      question: "How do I return or exchange a product?",
      answer: (
        <>
          <p>You can return or exchange a product within 7-10 days from the delivery date, provided it is in its original, unused condition with packaging intact. Please refer to our Return and Exchange Policy for more details.</p>
          <p>To initiate a return or exchange:</p>
          <ol>
            <li>Contact our customer support team at <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>.</li>
            <li>Provide your order number and the reason for the return or exchange.</li>
            <li>Follow the return instructions provided by our team.</li>
          </ol>
        </>
      ),
    },
    {
      question: "When will I receive my refund?",
      answer: <p>Once we receive your returned item, we will process your refund within 7-10 business days. Refunds are made to the original payment method, and depending on your payment provider, it may take a few additional days for the refund to reflect in your account.</p>,
    },
    {
      question: "How it Works?",
      answer: <section class="contact-us-wrap">
        <div >
          <div class="row justify-content-center">
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src="assets/img/cart.png" alt="" style={{ height: "50px" }} />
                <h6>Order</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <div>
                <h6>Order process begins when customers select products and confirm their purchase by making a payment.</h6>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <FcShipped style={{ fontSize: "50px" }} />
                <h6>Shipping</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <h6>Once the order is received, it is processed, packed, and shipped through reliable courier services.</h6>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src="assets/img/door.png" alt="" style={{ height: "50px" }} />
                <h6>Door Delivery</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <h6>The final step is door delivery, where the product is delivered directly to the customer’s address.</h6>
            </div>
          </div>

        </div>
      </section>
    },
    {
      question: "What should I do if I receive a damaged or defective product?",
      answer: (
        <>
          <p>If you receive a damaged or defective product, please contact us immediately at <a href="mailto:support@terrainternational.in">support@terrainternational.in</a> with the following:</p>
          <ul>
            <li>Your order number.</li>
            <li>A photo of the damaged or defective product.</li>
            <li>A photo of the packaging.</li>
          </ul>
          <p>We will assist you in returning or exchanging the product at no additional cost.</p>
        </>
      ),
    },
    {
      question: "How are shipping fees calculated?",
      answer: <p>Shipping fees are calculated based on your delivery address, the weight of the product(s), and the shipping method you select. You can view the shipping cost during the checkout process before finalizing your order.</p>,
    },
    {
      question: "Do you ship internationally?",
      answer: <p>Yes, we offer international shipping to select countries. You can check if we deliver to your location by entering your address at checkout. International shipping charges will apply.</p>,
    },
    {
      question: "Are your products authentic and original?",
      answer: <p>Yes, all products sold on our website are 100% authentic and are directly from manufacturers. We guarantee the quality and authenticity of the products we sell.</p>,
    },
    {
      question: "How do I contact customer support?",
      answer: (
        <>
          <p>For any questions or concerns, you can reach our customer support team through the following:</p>
          <ul>
            <li>Email: <a href="mailto:support@terrainternational.in">support@terrainternational.in</a></li>
            <li>Phone: 7022519222</li>
          </ul>
          <p>We’re available 24/7 and aim to respond to all queries within 48 hours.</p>
        </>
      ),
    },
    {
      question: "Do you offer discounts or promotions?",
      answer: <p>Yes, we occasionally offer discounts, promotions, and special deals. Make sure to subscribe to our newsletter or follow us on social media to stay updated on the latest offers.</p>,
    },
    {
      question: "What do I do if I forgot my password?",
      answer: <p>If you forgot your password, click on the "Forgot Password" link on the login page. Enter your registered email address, and we will send you instructions on how to reset your password.</p>,
    },
  ];
  const faqDatata = [
    {
      question: "நான் எப்படி ஒரு ஆர்டரை வைப்பது?",
      answer: (
        <>
          <p>ஆர்டர் செய்ய:</p>
          <ol>
            <li>எங்கள் தயாரிப்புகளை உலாவவும், உங்களுக்கு விருப்பமான பொருட்களை கூடையில் சேர்க்கவும்.</li>
            <li>நீங்கள் தயாரானதும், வண்டி ஐகானைக் கிளிக் செய்து செக் அவுட்டுக்குச் செல்லவும்.</li>
            <li>உங்கள் டெலிவரி விவரங்களை நிரப்பி, உங்களுக்கு விருப்பமான கட்டண முறையைத் தேர்வுசெய்யவும்.</li>
            <li>உங்கள் ஆர்டரை மதிப்பாய்வு செய்து உங்கள் கொள்முதலை உறுதிப்படுத்தவும்.</li>
            <li>உங்கள் ஆர்டர் வெற்றிகரமாக செய்யப்பட்டவுடன், ஆர்டர் உறுதிப்படுத்தல் மின்னஞ்சலைப் பெறுவீர்கள்.</li>
          </ol>
        </>
      ),
    },
    {
      question: "நீங்கள் என்ன கட்டண முறைகளை ஏற்றுக்கொள்கிறீர்கள்?",
      answer: (
        <>
          <p>பின்வரும் கட்டண முறைகளை நாங்கள் ஏற்றுக்கொள்கிறோம்:</p>
          <ul>
            <li>கிரெடிட்/டெபிட் கார்டுகள் (விசா, மாஸ்டர்கார்டு, முதலியன.)</li>
            <li>நிகர வங்கி</li>
            <li>UPI (ஒருங்கிணைந்த கட்டண இடைமுகம்)</li>
            <li>டெலிவரிக்குப் பணம் (COD) (பொருந்தினால்)</li>
          </ul>
        </>
      ),
    },
    {
      question: "எனது ஆர்டரை எவ்வாறு கண்காணிப்பது?",
      answer: <p>உங்கள் ஆர்டர் அனுப்பப்பட்டதும், கேரியர் விவரங்களுடன் ஒரு கண்காணிப்பு எண்ணைப் பெறுவீர்கள். கேரியரின் வலைத்தளத்திலோ அல்லது வழங்கப்பட்ட கண்காணிப்பு இணைப்பு மூலமாகவோ உங்கள் ஆர்டரின் நிலையைக் கண்காணிக்க இந்த கண்காணிப்பு எண்ணைப் பயன்படுத்தலாம்.</p>,
    },
    {
      question: "எனது ஆர்டரை வைத்த பிறகு அதை மாற்றவோ அல்லது ரத்து செய்யவோ முடியுமா?",
      answer: (
        <>
          <p>உங்கள் ஆர்டர் அனுப்பப்படவில்லை என்றால் மட்டுமே அதை மாற்றவோ அல்லது ரத்து செய்யவோ முடியும். உங்கள் ஆர்டர் இன்னும் செயலாக்க நிலையில் இருந்தால், உடனடியாக எங்கள் வாடிக்கையாளர் ஆதரவை இங்கே தொடர்பு கொள்ளவும்</p>
          <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>
          <p>மாற்றங்கள் அல்லது ரத்துசெய்தல்களைக் கோர.</p>
        </>
      ),
    },
    {
      question: "ஒரு பொருளை எப்படி திருப்பி அனுப்புவது அல்லது மாற்றுவது?",
      answer: (
        <>
          <p>ஒரு பொருளை டெலிவரி செய்த நாளிலிருந்து 7-10 நாட்களுக்குள் திருப்பி அனுப்பலாம் அல்லது மாற்றலாம், அது அதன் அசல், பயன்படுத்தப்படாத நிலையில் பேக்கேஜிங் அப்படியே இருந்தால். மேலும் விவரங்களுக்கு எங்கள் திரும்ப அனுப்புதல் மற்றும் பரிமாற்றக் கொள்கையைப் பார்க்கவும்.</p>
          <p>பணத்தைத் திரும்பப் பெறுதல் அல்லது பரிமாற்றத்தைத் தொடங்க:</p>
          <ol>
            <li>எங்கள் வாடிக்கையாளர் ஆதரவு குழுவை <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>என்ற மின்னஞ்சல் முகவரியில் தொடர்பு கொள்ளவும் .</li>
            <li>உங்கள் ஆர்டர் எண்ணையும், திரும்பப் பெறுதல் அல்லது பரிமாற்றத்திற்கான காரணத்தையும் வழங்கவும்.</li>
            <li>எங்கள் குழு வழங்கிய திருப்பி அனுப்பும் வழிமுறைகளைப் பின்பற்றவும்.</li>
          </ol>
        </>
      ),
    },
    {
      question: "எனது பணத்தை எப்போது திரும்பப் பெறுவேன்?",
      answer: <p>நீங்கள் திருப்பி அனுப்பிய பொருளைப் பெற்றவுடன், 7-10 வணிக நாட்களுக்குள் உங்கள் பணத்தைத் திரும்பப் பெறுவதை நாங்கள் செயல்படுத்துவோம். அசல் கட்டண முறைக்கு பணத்தைத் திரும்பப் பெறுவோம், மேலும் உங்கள் கட்டண வழங்குநரைப் பொறுத்து, பணத்தைத் திரும்பப் பெறுவது உங்கள் கணக்கில் பிரதிபலிக்க சில கூடுதல் நாட்கள் ஆகலாம்.</p>,
    },
    {
      question: "இது எப்படி செயல்படுகிறது?",
      answer: <section class="contact-us-wrap">
        <div >
          <div class="row justify-content-center">
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src="assets/img/cart.png" alt="" style={{ height: "50px" }} />
                <h6>ஆர்டர்</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <div>
                <h6>வாடிக்கையாளர்கள் பொருட்களைத் தேர்ந்தெடுத்து பணம் செலுத்துவதன் மூலம் தங்கள் கொள்முதலை உறுதிப்படுத்தும்போது ஆர்டர் செயல்முறை தொடங்குகிறது.</h6>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <FcShipped style={{ fontSize: "50px" }} />
                <h6>கப்பல் போக்குவரத்து</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <h6>ஆர்டர் கிடைத்ததும், அது பதப்படுத்தப்பட்டு, பேக் செய்யப்பட்டு, நம்பகமான கூரியர் சேவைகள் மூலம் அனுப்பப்படும்.</h6>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src="assets/img/door.png" alt="" style={{ height: "50px" }} />
                <h6>டோர் டெலிவரி</h6>
                <div style={{ height: "5px", width: "50px", backgroundColor: "green", borderRadius: "50px", marginBottom: "2vh" }}></div>
              </div>
              <h6>இறுதிப் படி வீட்டு வாசலில் டெலிவரி செய்வதாகும், அங்கு தயாரிப்பு நேரடியாக வாடிக்கையாளரின் முகவரிக்கு டெலிவரி செய்யப்படுகிறது.</h6>
            </div>
          </div>

        </div>
      </section>
    },
    {
      question: "சேதமடைந்த அல்லது குறைபாடுள்ள தயாரிப்பு கிடைத்தால் நான் என்ன செய்ய வேண்டும்?",
      answer: (
        <>
          <p>சேதமடைந்த அல்லது குறைபாடுள்ள தயாரிப்பை நீங்கள் பெற்றால், தயவுசெய்து உடனடியாக <a href="mailto:support@terrainternational.in">support@terrainternational.in</a> என்ற மின்னஞ்சல் முகவரியில் எங்களைத் தொடர்பு கொள்ளவும்:</p>
          <ul>
            <li>உங்கள் ஆர்டர் எண்.</li>
            <li>சேதமடைந்த அல்லது குறைபாடுள்ள தயாரிப்பின் புகைப்படம்.</li>
            <li>பேக்கேஜிங்கின் புகைப்படம்.</li>
          </ul>
          <p>கூடுதல் செலவு இல்லாமல் தயாரிப்பைத் திருப்பி அனுப்பவோ அல்லது மாற்றவோ நாங்கள் உங்களுக்கு உதவுவோம்.</p>
        </>
      ),
    },
    {
      question: "கப்பல் கட்டணங்கள் எவ்வாறு கணக்கிடப்படுகின்றன?",
      answer: <p>உங்கள் டெலிவரி முகவரி, தயாரிப்பு(கள்) எடை மற்றும் நீங்கள் தேர்ந்தெடுக்கும் ஷிப்பிங் முறை ஆகியவற்றின் அடிப்படையில் ஷிப்பிங் கட்டணம் கணக்கிடப்படுகிறது. உங்கள் ஆர்டரை இறுதி செய்வதற்கு முன், செக் அவுட் செயல்முறையின் போது ஷிப்பிங் செலவை நீங்கள் பார்க்கலாம்.</p>,
    },
    {
      question: "நீங்கள் சர்வதேச அளவில் அனுப்புகிறீர்களா?",
      answer: <p>ஆம், நாங்கள் குறிப்பிட்ட நாடுகளுக்கு சர்வதேச ஷிப்பிங்கை வழங்குகிறோம். செக் அவுட்டில் உங்கள் முகவரியை உள்ளிட்டு உங்கள் இடத்திற்கு நாங்கள் டெலிவரி செய்கிறோமா என்பதை நீங்கள் சரிபார்க்கலாம். சர்வதேச ஷிப்பிங் கட்டணங்கள் பொருந்தும்.</p>,
    },
    {
      question: "உங்கள் தயாரிப்புகள் உண்மையானவையா மற்றும் அசலானவையா?",
      answer: <p>ஆம், எங்கள் வலைத்தளத்தில் விற்கப்படும் அனைத்து தயாரிப்புகளும் 100% உண்மையானவை மற்றும் நேரடியாக உற்பத்தியாளர்களிடமிருந்து பெறப்பட்டவை. நாங்கள் விற்கும் பொருட்களின் தரம் மற்றும் நம்பகத்தன்மைக்கு நாங்கள் உத்தரவாதம் அளிக்கிறோம்.</p>,
    },
    {
      question: "வாடிக்கையாளர் ஆதரவை எவ்வாறு தொடர்பு கொள்வது?",
      answer: (
        <>
          <p>ஏதேனும் கேள்விகள் அல்லது கவலைகளுக்கு, பின்வருவனவற்றின் மூலம் எங்கள் வாடிக்கையாளர் ஆதரவுக் குழுவை நீங்கள் தொடர்பு கொள்ளலாம்:</p>
          <ul>
            <li>மின்னஞ்சல்: <a href="mailto:support@terrainternational.in">support@terrainternational.in</a></li>
            <li>தொலைபேசி: 7022519222</li>
          </ul>
          <p>நாங்கள் 24/7 கிடைக்கிறோம், மேலும் அனைத்து கேள்விகளுக்கும் 48 மணி நேரத்திற்குள் பதிலளிக்க இலக்கு வைத்துள்ளோம்.</p>
        </>
      ),
    },
    {
      question: "நீங்கள் தள்ளுபடிகள் அல்லது விளம்பரங்களை வழங்குகிறீர்களா?",
      answer: <p>ஆம், நாங்கள் அவ்வப்போது தள்ளுபடிகள், விளம்பரங்கள் மற்றும் சிறப்பு சலுகைகளை வழங்குகிறோம். சமீபத்திய சலுகைகளைப் பற்றி தொடர்ந்து தெரிந்துகொள்ள எங்கள் செய்திமடலுக்கு குழுசேரவும் அல்லது சமூக ஊடகங்களில் எங்களைப் பின்தொடரவும்.</p>,
    },
    {
      question: "எனது கடவுச்சொல்லை மறந்துவிட்டால் நான் என்ன செய்வது?",
      answer: <p>உங்கள் கடவுச்சொல்லை மறந்துவிட்டால், உள்நுழைவு பக்கத்தில் உள்ள "கடவுச்சொல் மறந்துவிட்டதா" என்ற இணைப்பைக் கிளிக் செய்யவும். உங்கள் பதிவுசெய்யப்பட்ட மின்னஞ்சல் முகவரியை உள்ளிடவும், உங்கள் கடவுச்சொல்லை எவ்வாறு மீட்டமைப்பது என்பது குறித்த வழிமுறைகளை நாங்கள் உங்களுக்கு அனுப்புவோம்.</p>,
    },
  ];
  const faqDataka = [
    {
      question: "ನಾನು ಆರ್ಡರ್ ಮಾಡುವುದು ಹೇಗೆ?",
      answer: (
        <>
          <p>ಆರ್ಡರ್ ಮಾಡಲು:</p>
          <ol>
            <li>ನಮ್ಮ ಉತ್ಪನ್ನಗಳನ್ನು ಬ್ರೌಸ್ ಮಾಡಿ ಮತ್ತು ನಿಮಗೆ ಬೇಕಾದ ವಸ್ತುಗಳನ್ನು ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ.</li>
            <li>ನೀವು ಸಿದ್ಧರಾದ ನಂತರ, ಕಾರ್ಟ್ ಐಕಾನ್ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ಚೆಕ್ಅವುಟ್ಗೆ ಮುಂದುವರಿಯಿರಿ.</li>
            <li>ನಿಮ್ಮ ವಿತರಣಾ ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಆದ್ಯತೆಯ ಪಾವತಿ ವಿಧಾನವನ್ನು ಆಯ್ಕೆಮಾಡಿ.</li>
            <li>ನಿಮ್ಮ ಆರ್ಡರ್ ಅನ್ನು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ನಿಮ್ಮ ಖರೀದಿಯನ್ನು ದೃಢೀಕರಿಸಿ.</li>
            <li>ನಿಮ್ಮ ಆರ್ಡರ್ ಯಶಸ್ವಿಯಾಗಿ ಮಾಡಿದ ನಂತರ ನೀವು ಆರ್ಡರ್ ದೃಢೀಕರಣ ಇಮೇಲ್ ಅನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.</li>
          </ol>
        </>
      ),
    },
    {
      question: "ನೀವು ಯಾವ ಪಾವತಿ ವಿಧಾನಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ?",
      answer: (
        <>
          <p>ನಾವು ಕೆಳಗಿನ ಪಾವತಿ ವಿಧಾನಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತೇವೆ:</p>
          <ul>
            <li>ಕ್ರೆಡಿಟ್/ಡೆಬಿಟ್ ಕಾರ್ಡ್ಗಳು (ವಿಸಾ, ಮಾಸ್ಟರ್ ಕಾರ್ಡ್ ಇತ್ಯಾದಿ)</li>
            <li>ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್</li>
            <li>UPI (ಏಕೀಕೃತ ಪಾವತಿ ವಿಧಾನ)</li>
            <li>ವಿತರಣೆಯ ಸಮಯದಲ್ಲಿ ಹಣ ಪಾವತಿ (COD) (ಅನ್ವಯಿಸಿದರೆ)</li>
          </ul>
        </>
      ),
    },
    {
      question: "ನನ್ನ ಆರ್ಡರ್ ಅನ್ನು ನಾನು ಹೇಗೆ ಟ್ರ್ಯಾಕ್ ಮಾಡಬಹುದು?",
      answer: (
        <p>
          ನಿಮ್ಮ ಆರ್ಡರ್ ರವಾನೆಯಾದ ನಂತರ, ವಾಹಕ ವಿವರಗಳೊಂದಿಗೆ ನೀವು ಒಂದು ಟ್ರ್ಯಾಕಿಂಗ್ ಸಂಖ್ಯೆಯನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.
          ವಾಹಕದ ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿ ಅಥವಾ ಒದಗಿಸಲಾದ ಟ್ರ್ಯಾಕಿಂಗ್ ಲಿಂಕ್ ಮೂಲಕ ನಿಮ್ಮ ಆರ್ಡರ್‌ನ ಸ್ಥಿತಿಯನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಲು ನೀವು ಈ ಟ್ರ್ಯಾಕಿಂಗ್ ಸಂಖ್ಯೆಯನ್ನು ಬಳಸಬಹುದು.
        </p>
      ),
    },
    {
      question: "ನಾನು ಆರ್ಡರ್ ಮಾಡಿದ ನಂತರ ಅದನ್ನು ಬದಲಾಯಿಸಬಹುದೆಯೇ ಅಥವಾ ರದ್ದುಗೊಳಿಸಬಹುದೆಯೇ?",
      answer: (
        <>
          <p>
            ನಿಮ್ಮ ಆರ್ಡರ್ ರವಾನೆಯಾಗಿಲ್ಲದಿದ್ದರೆ ಮಾತ್ರ ನೀವು ಅದನ್ನು ಮಾರ್ಪಡಿಸಬಹುದು ಅಥವಾ ರದ್ದುಗೊಳಿಸಬಹುದು. 
            ನಿಮ್ಮ ಆರ್ಡರ್ ಇನ್ನೂ ಪ್ರಕ್ರಿಯೆ ಹಂತದಲ್ಲಿದ್ದರೆ, ತಕ್ಷಣ ನಮ್ಮ ಗ್ರಾಹಕ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ:
          </p>
          <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>
        </>
      ),
    },
    {
      question: "ಉತ್ಪನ್ನವನ್ನು ಹಿಂದಿರುಗಿಸುವುದು ಅಥವಾ ವಿನಿಮಯ ಮಾಡಿಕೊಳ್ಳುವುದು ಹೇಗೆ?",
      answer: (
        <>
          <p>
            ವಿತರಣಾ ದಿನಾಂಕದಿಂದ 7-10 ದಿನಗಳ ಒಳಗೆ, ಉತ್ಪನ್ನವು ಅದರ ಮೂಲ, ಬಳಕೆಯಾಗದ ಸ್ಥಿತಿಯಲ್ಲಿದ್ದರೆ ಮತ್ತು ಪ್ಯಾಕೇಜಿಂಗ್ ಹಾನಿಯಾಗದಿದ್ದರೆ,
            ನೀವು ಅದನ್ನು ಹಿಂತಿರುಗಿಸಬಹುದು ಅಥವಾ ವಿನಿಮಯ ಮಾಡಿಕೊಳ್ಳಬಹುದು.
          </p>
          <p>ವಾಪಸಾತಿ ಅಥವಾ ವಿನಿಮಯವನ್ನು ಪ್ರಾರಂಭಿಸಲು:</p>
          <ol>
            <li>
              ನಮ್ಮ ಗ್ರಾಹಕ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ: <a href="mailto:support@terrainternational.in">support@terrainternational.in</a>
            </li>
            <li>ನಿಮ್ಮ ಆರ್ಡರ್ ಸಂಖ್ಯೆ ಮತ್ತು ಹಿಂತಿರುಗಿಸುವಿಕೆ ಅಥವಾ ವಿನಿಮಯಕ್ಕೆ ಕಾರಣವನ್ನು ಒದಗಿಸಿ.</li>
            <li>ನಮ್ಮ ತಂಡವು ಒದಗಿಸಿದ ಹಿಂತಿರುಗಿಸುವ ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸಿ.</li>
          </ol>
        </>
      ),
    },
    {
      question: "ನನಗೆ ಮರುಪಾವತಿ ಯಾವಾಗ ದೊರೆಯುತ್ತದೆ?",
      answer: (
        <p>
          ಮರಳಿ ಕಳುಹಿಸಿದ ವಸ್ತುವನ್ನು ಸ್ವೀಕರಿಸಿದ ನಂತರ, ನಾವು 7-10 ವ್ಯಾಪಾರದ ದಿನಗಳಲ್ಲಿ ನಿಮ್ಮ ಹಿಂಪಡೆಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುತ್ತೇವೆ.
          ಹಿಂಪಡೆಯು ಮೂಲ ಪಾವತಿ ವಿಧಾನಕ್ಕೆ ಮಾಡಲಾಗುತ್ತದೆ, ಮತ್ತು ನಿಮ್ಮ ಪಾವತಿ ಒದಗಿಸುವವರ ಅವಲಂಬಿತವಾಗಿ, ಹಿಂಪಡೆಯು ನಿಮ್ಮ ಖಾತೆಯಲ್ಲಿ ಪ್ರತಿಬಿಂಬಿಸಲು ಕೆಲವು ಹೆಚ್ಚುವರಿ ದಿನಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳಬಹುದು.
        </p>
      ),
    },
    {
      question: "ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ?",
      answer: (
        <section>
          <div>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <div style={{ textAlign: "center" }}>
                <img src="assets/img/cart.png" alt="Order" style={{ height: "50px" }} />
                <h6>ಆರ್ಡರ್</h6>
                <p>ಗ್ರಾಹಕರು ಉತ್ಪನ್ನಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ ಪಾವತಿ ಮಾಡುವ ಮೂಲಕ ತಮ್ಮ ಖರೀದಿಯನ್ನು ದೃಢೀಕರಿಸಿದಾಗ ಆರ್ಡರ್ ಪ್ರಕ್ರಿಯೆಯು ಪ್ರಾರಂಭವಾಗುತ್ತದೆ.</p>
              </div>
              <div style={{ textAlign: "center" }}>
                <FcShipped style={{ fontSize: "50px" }} />
                <h6>ಸಾಗಣೆ</h6>
                <p>ಆರ್ಡರ್ ಸ್ವೀಕರಿಸಿದ ನಂತರ, ಅದನ್ನು ಸಂಸ್ಕರಿಸಿ, ಪ್ಯಾಕ್ ಮಾಡಿ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಕೊರಿಯರ್ ಸೇವೆಗಳ ಮೂಲಕ ರವಾನಿಸಲಾಗುತ್ತದೆ.</p>
              </div>
              <div style={{ textAlign: "center" }}>
                <img src="assets/img/door.png" alt="Delivery" style={{ height: "50px" }} />
                <h6>ಬಾಗಿಲ ಬಳಿ ವಿತರಣೆ</h6>
                <p>ಉತ್ಪನ್ನವನ್ನು ನೇರವಾಗಿ ಗ್ರಾಹಕರ ವಿಳಾಸಕ್ಕೆ ತಲುಪಿಸಲಾಗುತ್ತದೆ.</p>
              </div>
            </div>
          </div>
        </section>
      ),
    },
    {
      question: "ನಾನು ಹಾನಿಗೊಳಗಾದ ಅಥವಾ ದೋಷಯುಕ್ತ ಉತ್ಪನ್ನವನ್ನು ಸ್ವೀಕರಿಸಿದರೆ ನಾನು ಏನು ಮಾಡಬೇಕು?",
      answer: (
        <>
          <p>ನೀವು ಹಾನಿಗೊಳಗಾದ ಅಥವಾ ದೋಷಯುಕ್ತ ಉತ್ಪನ್ನವನ್ನು ಸ್ವೀಕರಿಸಿದರೆ, ದಯವಿಟ್ಟು ನಮ್ಮನ್ನು ತಕ್ಷಣ ಸಂಪರ್ಕಿಸಿ:</p>
          <ul>
            <li>ನಿಮ್ಮ ಆರ್ಡರ್ ಸಂಖ್ಯೆ.</li>
            <li>ಹಾನಿಗೊಳಗಾದ ಅಥವಾ ದೋಷಯುಕ್ತ ಉತ್ಪನ್ನದ ಫೋಟೋ.</li>
            <li>ಪ್ಯಾಕೇಜಿಂಗ್‌ನ ಫೋಟೋ.</li>
          </ul>
          <p>ನಾವು ನಿಮಗೆ ಹೊಸ ಉತ್ಪನ್ನವನ್ನು ವಿನಿಮಯ ಮಾಡಿಕೊಡಲು ಅಥವಾ ಹಿಂತಿರುಗಿಸುವ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿ ಸಹಾಯ ಮಾಡುತ್ತೇವೆ.</p>
        </>
      ),
    },
    {
      question: "ನೀವು ರಿಯಾಯಿತಿಗಳು ಅಥವಾ ಪ್ರಚಾರಗಳನ್ನು ನೀಡುತ್ತೀರಾ?",
      answer: (
        <p>
          ಹೌದು, ನಾವು ಕೆಲವೊಮ್ಮೆ ರಿಯಾಯಿತಿಗಳು, ಪ್ರಚಾರಗಳು ಮತ್ತು ವಿಶೇಷ ಒಪ್ಪಂದಗಳನ್ನು ನೀಡುತ್ತೇವೆ.
          ಇತ್ತೀಚಿನ ಕೊಡುಗೆಗಳ ಕುರಿತು ನವೀಕೃತವಾಗಿರಲು ನಮ್ಮ ಸುದ್ದಿಪತ್ರಕ್ಕೆ ಚಂದಾದಾರರಾಗಿರಿ ಅಥವಾ ನಮ್ಮ ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮಗಳನ್ನು ಅನುಸರಿಸಿ.
        </p>
      ),
    },
    {
      question: "ನೀವು ಅಂತರರಾಷ್ಟ್ರೀಯವಾಗಿ ಸಾಗಿಸುತ್ತೀರಾ?",
      answer: (
        <p>
          ಹೌದು, ನಾವು ಆಯ್ದ ದೇಶಗಳಿಗೆ ಅಂತರರಾಷ್ಟ್ರೀಯ ಸಾಗಾಟವನ್ನು ನೀಡುತ್ತೇವೆ.
          ಚೆಕ್‌ಔಟ್‌ನಲ್ಲಿ ನಿಮ್ಮ ವಿಳಾಸವನ್ನು ನಮೂದಿಸುವ ಮೂಲಕ ನಾವು ನಿಮ್ಮ ಸ್ಥಳಕ್ಕೆ ತಲುಪಿಸುತ್ತೇವೆಯೇ ಎಂದು ಪರಿಶೀಲಿಸಬಹುದು.
        </p>
      ),
    },
    {
      question: "ನಾನು ಗ್ರಾಹಕ ಬೆಂಬಲವನ್ನು ಹೇಗೆ ಸಂಪರ್ಕಿಸಬಹುದು?",
      answer: (
        <>
          <p>ನೀವು ಈ ಕೆಳಗಿನವುಗಳ ಮೂಲಕ ನಮ್ಮ ಗ್ರಾಹಕ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಬಹುದು:</p>
          <ul>
            <li>ಇಮೇಲ್: <a href="mailto:support@terrainternational.in">support@terrainternational.in</a></li>
            <li>ದೂರವಾಣಿ: 7022519222</li>
          </ul>
        </>
      ),
    },
  ];
  const [fb,setFB] =useState(fben)
    const [faqData, setfaqData] = useState(faqDatae)
      useEffect(() => {
          const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
      switch (storedLanguage) {
          case "kn":
            setfaqData(faqDataka);
            setFB(fbka);
              break;
          case "te":
            setfaqData(faqDatate);
            setFB(fbte);
              break;
          case "ta":
            setfaqData(faqDatata);
            setFB(fbta);
              break;
              case "hi":
            setfaqData(faqDatahi);
            setFB(fbhi);
              break;
          default:
            setfaqData(faqDatae);
            setFB(fben);
      }
  
  }, []);
  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container">
          <div className="breadcrumb-title">
            <h2>{fb["1"]}</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">{fb["2"]}</Link></li>
              <li>{fb["1"]}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="faqs-container">
        {faqData.map((item, index) => (
          <div className="faq" key={index}>
            <h6 onClick={() => toggleFAQ(index)} className="faq-question">
              {item.question} {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </h6>
            <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
              {openIndex === index && item.answer}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
export default FAQ;
